module.exports = function() {
  return new Worker(__webpack_public_path__ + "206a31145530c1860b88.worker.js");
};